import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import userAuth from '../hooks/userAuth';
import {
  IGetInstitutionCustomTexts,
  useQueryGetInstitutionCustomTexts,
} from '../operations/query/institutions/useGetInstitutionCustomTexts';
import { useQueryGetGlobalCustomTexts } from '../operations/query/public/institutions/useGetGlobalCustomTexts';
import { ROLE_ENUM } from '../views/Auth/Login/interfaces/IGoogleUser';

interface IInstitutionCustomTexts {
  loading: boolean;
  customTexts: IGetInstitutionCustomTexts[];
  institutionId: string | null | undefined;
  setInstitutionId: (id: string | null | undefined) => void;
}

export interface IInstitutionCustomText {
  loading: boolean;
  description?: string;
}

interface IInstitutionCustomTextsProviderProps {
  children: ReactNode;
}

export enum TypeCustomTexts {
  FOOTER = 'FOOTER',
  COURSE_RECOMMENDATIONS_MESSAGE = 'COURSE_RECOMMENDATIONS_MESSAGE',
  SKILLS_SECTION = 'SKILLS_SECTION',
  LEARNING_PATH_SECTION = 'LEARNING_PATH_SECTION',
  WIZARD_STEP_1 = 'WIZARD_STEP_1',
  WIZARD_STEP_2 = 'WIZARD_STEP_2',
  WIZARD_STEP_3 = 'WIZARD_STEP_3',
  LP_COURSES_NUMBER_PROVIDER_RIIPEN_TEXT = 'LP_COURSES_NUMBER_PROVIDER_RIIPEN_TEXT',
  LP_COURSES_NUMBER_PROVIDER_GOOGLE_TEXT = 'LP_COURSES_NUMBER_PROVIDER_GOOGLE_TEXT',
  STUDENT_TYPE_INPUT_LABEL = 'STUDENT_TYPE_INPUT_LABEL',
  QSEM_PROVIDER_CARDS_TITLE = 'QSEM_PROVIDER_CARDS_TITLE',
  CAREER_GOALS_IWANT_REAL_WORLD_PROJECTS_TITLE = 'CAREER_GOALS_IWANT_REAL_WORLD_PROJECTS_TITLE',
  CAREER_GOALS_IWANT_REAL_WORLD_PROJECTS_SUBTITLE = 'CAREER_GOALS_IWANT_REAL_WORLD_PROJECTS_SUBTITLE',
  CAREER_GOALS_NOTFORME_REAL_WORLD_PROJECTS_BUTTON_TEXT = 'CAREER_GOALS_NOTFORME_REAL_WORLD_PROJECTS_BUTTON_TEXT',
  CAREER_GOALS_IAMINTERESTED_REAL_WORLD_PROJECTS_BUTTON_TEXT = 'CAREER_GOALS_IAMINTERESTED_REAL_WORLD_PROJECTS_BUTTON_TEXT',
  CAREER_GOALS_FEEDBACKSENDED_REAL_WORLD_PROJECTS_TITLE = 'CAREER_GOALS_FEEDBACKSENDED_REAL_WORLD_PROJECTS_TITLE',
  CAREER_GOALS_FEEDBACKSENDED_REAL_WORLD_PROJECTS_SUBTITLE = 'CAREER_GOALS_FEEDBACKSENDED_REAL_WORLD_PROJECTS_SUBTITLE',
  CAREER_GOALS_REAL_WORLD_EMPLOYER_PROJECTS_TITLE = 'CAREER_GOALS_REAL_WORLD_EMPLOYER_PROJECTS_TITLE',
  CAREER_GOALS_REAL_WORLD_EMPLOYER_PROJECTS_SUBTITLE = 'CAREER_GOALS_REAL_WORLD_EMPLOYER_PROJECTS_SUBTITLE',
  COURSE_PRICE_MESSAGE = 'COURSE_PRICE_MESSAGE',
  COURSE_MODAL_INTEREST_DESCRIPTION = 'COURSE_MODAL_INTEREST_DESCRIPTION',
  CAREER_FIELDS_EMPTY_STATE_BUTTON = 'CAREER_FIELDS_EMPTY_STATE_BUTTON',
  CAREER_FIELDS_EXPLORE_BY_FIELD_OF_STUDY = 'CAREER_FIELDS_EXPLORE_BY_FIELD_OF_STUDY',
  CAREER_FIELDS_EMPTY_STATE_FILTER = 'CAREER_FIELDS_EMPTY_STATE_FILTER',
  CAREER_FIELDS_EMPTY_STATE_FILTER_SUBTITLE = 'CAREER_FIELDS_EMPTY_STATE_FILTER_SUBTITLE',
  CAREER_FIELDS_EMPTY_STATE_FILTER_SUBTITLE_ADVISOR = 'CAREER_FIELDS_EMPTY_STATE_FILTER_SUBTITLE_ADVISOR',
  CAREER_FIELDS_FILTER_PLACEHOLDER = 'CAREER_FIELDS_FILTER_PLACEHOLDER',
  CAREER_FIELDS_FILTER_TITLE = 'CAREER_FIELDS_FILTER_TITLE',
  CAREER_FIELDS_SUMMARY_USER_TITLE = 'CAREER_FIELDS_SUMMARY_USER_TITLE',
  CAREER_FIELDS_QUESTION_TITLE = 'CAREER_FIELDS_QUESTION_TITLE',
  CAREER_FIELDS_INPUT_PLACEHOLDER = 'CAREER_FIELDS_INPUT_PLACEHOLDER',
  CAREER_FIELDS_SUBTITLE_INSTITUTION_EMPTY_STATE = 'CAREER_FIELDS_SUBTITLE_INSTITUTION_EMPTY_STATE',
  CAREER_FIELDS_TOP_OCCUPATIONS_SUBTITLE_EMPTY_STATE = 'CAREER_FIELDS_TOP_OCCUPATIONS_SUBTITLE_EMPTY_STATE',
  CAREER_FIELDS_TITLE_LIST_CARD = 'CAREER_FIELDS_TITLE_LIST_CARD',
  CAREER_FIELDS_EMPTY_STATE_SUBTITLE = 'CAREER_FIELDS_EMPTY_STATE_SUBTITLE',
  CAREER_FIELDS_EMPTY_STATE_TOP_SUBTITLE = 'CAREER_FIELDS_EMPTY_STATE_TOP_SUBTITLE',
  CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_TITLE = 'CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_TITLE',
  CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_SUBTITLE_1 = 'CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_SUBTITLE_1',
  CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_SUBTITLE_2 = 'CAREER_FIELDS_RECOMMENDED_OCCUPATIONS_SUBTITLE_2',
  CAREER_FIELDS_INSTITUTION_PATHS_TITLE = 'CAREER_FIELDS_INSTITUTION_PATHS_TITLE',
  CAREER_FIELDS_INSTITUTION_PATHS_SUBTITLE = 'CAREER_FIELDS_INSTITUTION_PATHS_SUBTITLE',
  CAREER_FIELDS_PLACEHOLDER_FILTER = 'CAREER_FIELDS_PLACEHOLDER_FILTER',
  QS_INSTANCE_EMPTY_STATE_PROVIDERS_TITLE = 'QS_INSTANCE_EMPTY_STATE_PROVIDERS_TITLE',
  QS_INSTANCE_EMPTY_STATE_PROVIDERS_SUBTITLE = 'QS_INSTANCE_EMPTY_STATE_PROVIDERS_SUBTITLE',
  WIZARD_CAREER_GOALS_TITLE = 'WIZARD_CAREER_GOALS_TITLE',
  WIZARD_CAREER_GOALS_SUBTITLE = 'WIZARD_CAREER_GOALS_SUBTITLE',
  WIZARD_SKILLS_TITLE = 'WIZARD_SKILLS_TITLE',
  WIZARD_SKILLS_SUBTITLE = 'WIZARD_SKILLS_SUBTITLE',
  ACADEMIC_PROGRAM_SECTION_TITLE = 'ACADEMIC_PROGRAM_SECTION_TITLE',
  ACADEMIC_PROGRAM_INPUT_LABEL = 'ACADEMIC_PROGRAM_INPUT_LABEL',
  INSTITUTION_INPUT_LABEL = 'INSTITUTION_INPUT_LABEL',
  DESCRIPTION_IKIGAI = 'DESCRIPTION_IKIGAI',
  CUSTOM_TEXT_FORCE_LP_CARD_COURSES = 'CUSTOM_TEXT_FORCE_LP_CARD_COURSES',
  LEGAL_DISCLAIMER_LOGIN_PAGE = 'LEGAL_DISCLAIMER_LOGIN_PAGE',
  WIZARD_SKILLS_TITLE_PLAR = 'WIZARD_SKILLS_TITLE_PLAR',
  WIZARD_SUBMISSION_TITLE_PLAR = 'WIZARD_SUBMISSION_TITLE_PLAR',
  WIZARD_SUBMISSION_INSTITUTION_URL = 'WIZARD_SUBMISSION_INSTITUTION_URL',
  WIZARD_SUBMISSION_CONTACT_EMAIL = 'WIZARD_SUBMISSION_CONTACT_EMAIL',
  CONFIRMATION_PAGE_TITLE = 'CONFIRMATION_PAGE_TITLE',
  CONFIRMATION_PAGE_SUBTITLE = 'CONFIRMATION_PAGE_SUBTITLE',
  CONFIRMATION_PAGE_BODY = 'CONFIRMATION_PAGE_BODY',
  CONFIRMATION_PAGE_BUTTON_TEXT = 'CONFIRMATION_PAGE_BUTTON_TEXT',
  CONFIRMATION_PAGE_BUTTON_LINK = 'CONFIRMATION_PAGE_BUTTON_LINK',
  CONFIRMATION_PAGE_FOOTER_QUESTION = 'CONFIRMATION_PAGE_FOOTER_QUESTION',
  CONFIRMATION_PAGE_FOOTER_CONTACT = 'CONFIRMATION_PAGE_FOOTER_CONTACT',
  CONFIRMATION_PAGE_FOOTER_EMAIL = 'CONFIRMATION_PAGE_FOOTER_EMAIL',
}

export const institutionCustomTextInitialState: IInstitutionCustomTexts = {
  loading: false,
  customTexts: [],
  institutionId: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setInstitutionId: () => {},
};

export const InstitutionCustomTextsContext = createContext<IInstitutionCustomTexts>(institutionCustomTextInitialState);

const mergeCustomTexts = (
  globalTexts: IGetInstitutionCustomTexts[],
  institutionTexts: IGetInstitutionCustomTexts[],
): IGetInstitutionCustomTexts[] => {
  const mergedMap = new Map<string, IGetInstitutionCustomTexts>();

  globalTexts.forEach((text) => mergedMap.set(text.textKey, text));
  institutionTexts.forEach((text) => mergedMap.set(text.textKey, text));

  return Array.from(mergedMap.values());
};

export const InstitutionCustomTextsProvider: React.FC<IInstitutionCustomTextsProviderProps> = ({ children }) => {
  const { auth } = userAuth();
  const { i18n } = useTranslation();
  const [institutionId, setInstitutionId] = useState<string | null | undefined>(undefined);
  const userInstitutionId =
    auth?.userRole === ROLE_ENUM.STUDENT ? auth?.studentInstitution?.institutionId : auth?.advisor?.institutionId;
  const finalInstitutionId = institutionId === undefined ? userInstitutionId : institutionId;
  const languageId = auth?.preferredLanguage ?? i18n.language ?? 'en';

  const { data: globalData, loading: globalLoading } = useQueryGetGlobalCustomTexts({
    languageId,
  });

  const { data: institutionData, loading: institutionLoading } = useQueryGetInstitutionCustomTexts(
    {
      institutionId: finalInstitutionId,
      languageId,
    },
    {
      skip: !finalInstitutionId || !languageId,
    },
  );

  const loading = globalLoading || institutionLoading;

  const [customTexts, setCustomTexts] = useState<IGetInstitutionCustomTexts[]>([]);

  useEffect(() => {
    const globalTexts = globalData?.getGlobalCustomTexts ?? [];
    const institutionTexts = institutionData?.getInstitutionCustomTexts ?? [];

    setCustomTexts(mergeCustomTexts(globalTexts, institutionTexts));
  }, [globalData, institutionData]);

  const value = useMemo(
    () => ({
      loading,
      customTexts,
      institutionId: finalInstitutionId,
      setInstitutionId,
    }),
    [loading, customTexts, finalInstitutionId],
  );

  return <InstitutionCustomTextsContext.Provider value={value}>{children}</InstitutionCustomTextsContext.Provider>;
};

export const useCustomTexts = (): IInstitutionCustomTexts => useContext(InstitutionCustomTextsContext);

export const useCustomText = (key: TypeCustomTexts): IInstitutionCustomText => {
  const { loading, customTexts } = useContext(InstitutionCustomTextsContext);
  const description = loading
    ? undefined
    : customTexts.find((customText) => customText.textKey === key)?.textValue ?? undefined;

  return { loading, description };
};
